/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withTranslation } from "react-i18next";
import styles from "./ReviewSummaryView.module.scss";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { homeHeatingOptions } from "../../../../shared/const/data";

const HomeHeatingSummary = ({ t, i18n, setIsError }) => {
  const navigate = useNavigate();
  const { questionDataList } = useSelector((state) => state.app);

  const appliedHomeHeating =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 13)
    ].questionAnswer;

  const proofOfHomeHeating =
    questionDataList[
      questionDataList.findIndex((question) => question.questionNumber === 14)
    ].questionAnswer?.toLowerCase() === 'no';

  const heatingBillFiles = useSelector((state) => state.app.heatingBill);
  let homeHeatingValues = homeHeatingOptions.find(
    (op) => op.value === appliedHomeHeating
  );

  const editHomeHeatingOnClick = (e) => {
    e.preventDefault();
    try {
      navigate(`/${i18n.language}${t("routes.heat_your_home")}?isSummary=true`);
    } catch (e) {
      console.log(e);
      setIsError(true);
    }
  };

  return (
    <div className="row">
      <div className="col-xs-12 col-lg-9">
        <div className="col-xs-12">
          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div
              style={{
                display: "flex",
                flexGrow: 1,
                justifyContent: "flex-start",
                alignItems: "center"
              }}
            >
              <div style={{ margin: '0px 6px' }}>
                <h3>{t("review_summary.home_heating_service")}</h3>
              </div>
              <div style={{ margin: '0px 1em' }}>
                <a
                  id="edit-home-heating"
                  href="#"
                  className={[styles["edit_button"]].join(" ")}
                  onClick={editHomeHeatingOnClick}
                  value={t("shared.edit")}
                  name={t("shared.edit")}
                >
                  <i
                    aria-label={t("shared.edit")}
                    className="fa fa-pencil-alt"
                    aria-hidden="true"
                  ></i>
                  {t("shared.edit")}
                </a>
              </div>
            </div>
          </div>

          <div className="row" style={{ display: "flex", flexGrow: 1 }}>
            <div className="col-xs-12 col-md-9">
              <strong>{t("review_summary.home_heating_section1")}</strong>
            </div>
            <div className="col-xs-9 col-md-3">
              {i18n.language === "fr"
                ? homeHeatingValues?.valueFrench
                : homeHeatingValues?.displayName}
            </div>
          </div>
          <hr />
          {heatingBillFiles && heatingBillFiles?.length > 0 ? (
            <> <div className="row" style={{ display: "flex", flexGrow: 1 }}>
              <div className="col-xs-9 col-md-9">
                <strong>{t("review_summary.home_heating_section2")}</strong>
              </div>
              <div className="col-xs-3 col-md-3">
                {heatingBillFiles?.map((file, i) => (
                  <span key={i + file.name}>
                    {file.name}
                    <br />
                  </span>
                ))}
              </div>
            </div>
              <hr /></>
          ) : ''}
          <>
            {!heatingBillFiles?.length > 0 && <><div className="row" style={{ display: "flex", flexGrow: 1 }}>
              <div className="col-xs-12 col-md-9">
                <strong>{t("review_summary.understand_delay")}</strong>
              </div>
              <div className="col-xs-12 col-md-3">
                {t("review_summary.agreed")}
              </div>
            </div>
              <hr /></>}
            {heatingBillFiles && heatingBillFiles?.length < 1 ? (
              <>
                <div className="row" style={{ display: "flex", flexGrow: 1 }}>
                  <div className="col-xs-12 col-md-9">
                    <strong>{t("review_summary.continue_without_upload")}</strong>
                  </div>
                  <div className="col-xs-12 col-md-3">
                    {t("review_summary.agreed")}
                  </div>
                </div>
                <hr />
              </>
            ) : ''}
          </>

        </div>
      </div>
    </div>
  );
};

export default withTranslation("common")(HomeHeatingSummary);
